import gql from "graphql-tag";
import graphqlClient from "@/http/graphql/inside";
import graphqlCmlink from "@/http/graphql/link";
import graphqlCmcard from "@/http/graphql/card";

const UPDATE_USER_PROFILE = `
    update_info (name: $name, avatar: $avatar) {
        id
		name
		gender
		phone
		email
		dob
		avatar(w: 100, h: 100)
		cluster_id
		cluster {
			name
			company {
				name
				address
				logo (w: 90, h: 90)
			}
		}
	}
`;

const UPDATE_PASSWORD = `
    change_password (oldPassword: $oldPassword, newPassword: $newPassword)
`;

const USER_SETTINGS = `
	user_settings {
		id
		content
	}
`;

const TIMEZONES = `
	timezones {
		key
		value
	}`;
const LOCALES = `
	locales {
		key
		value
	}`;
const DATETIMES = `
	datetimes {
		key
		value
	}`;

const UPDATE_USER_SETTINGS = `
	user_settings_mutation(settings: $settings) {
		id
		content
  	}`;

const UPDATE_EMPLOYEE_POINT = `
		update_employee_point(school_year: $schoolYear, semester: $semester, course_point: $coursePoint, school_training_point: $schoolTrainingPoint, files: $files) {
        id
        school_year
        semester
        course_point
        school_training_point
        dormitory_training_point
        files
        confirmed
        created_at
        updated_at
        attachs {
            id
            path
        }
    }`;

const UPDATE_EMPLOYEE_POINTS = `
	update_employee_points_multi (data: $data) {
		id
        school_year
        semester
        course_point
        school_training_point
        dormitory_training_point
        files
		attachs {
			id
			path
			file_name
			extension
		}
        confirmed
        created_at
        updated_at
	}`;

export default {
	init() {},

	updateUserInfo(payload) {
		const queryOptions = {
			mutation: gql`mutation UpdateUserInfo ($name: String, $avatar: Upload) {
					${UPDATE_USER_PROFILE}
				}
			`,
			variables: {
				name: payload.name || "",
				avatar: payload.avatar || null
			}
		};

		return graphqlClient.mutate(queryOptions).then(response => {
			return {
				role: response.data.update_info
			};
		});
	},

	changePassword(payload) {
		const queryOptions = {
			mutation: gql`mutation UpdatePassword ($oldPassword: String, $newPassword: String) {
					${UPDATE_PASSWORD}
				}
			`,
			variables: {
				oldPassword: payload.oldPassword || "",
				newPassword: payload.newPassword || ""
			}
		};

		return graphqlClient.mutate(queryOptions).then(response => {
			return {
				changePassword: response.data.change_password
			};
		});
	},
	fetchUserSettings() {
		const queryOptions = {
			query: gql`query UserSettings {
				${USER_SETTINGS}
			}
			`
		};

		return graphqlCmlink.query(queryOptions).then(response => {
			return {
				user_settings: response.data.user_settings
			};
		});
	},
	fetchTimezones() {
		const queryOptions = {
			query: gql`query TIMEZONES {
				${TIMEZONES}
			}
			`
		};

		return graphqlCmlink.query(queryOptions).then(response => {
			return {
				timezones: response.data.timezones
			};
		});
	},

	fetchLocales() {
		const queryOptions = {
			query: gql`query LOCALES {
				${LOCALES}
			}
			`
		};

		return graphqlCmlink.query(queryOptions).then(response => {
			return {
				locales: response.data.locales
			};
		});
	},

	fetchDatetimes() {
		const queryOptions = {
			query: gql`query DATETIMES {
				${DATETIMES}
			}
			`
		};

		return graphqlCmlink.query(queryOptions).then(response => {
			return {
				datetimes: response.data.datetimes
			};
		});
	},

	updateUserSettings(payload) {
		const queryOptions = {
			mutation: gql`mutation UpdateUserSetting ($settings: String) {
				${UPDATE_USER_SETTINGS}
			}
			`,
			variables: {
				settings: payload.settings || ""
			}
		};

		return graphqlCmlink.mutate(queryOptions).then(response => {
			return {
				settings: response.data.user_settings_mutation
			};
		});
	},

	updateEmployeePoint(payload) {
		const queryOptions = {
			mutation: gql`mutation UpdatePoint ($schoolYear: Int!, $semester: Int!, $coursePoint: Float!, $schoolTrainingPoint: Float!, $files: [Int]) {
				${UPDATE_EMPLOYEE_POINT}
			}
			`,
			variables: {
				schoolYear: payload.school_year,
				semester: payload.semester,
				coursePoint: payload.course_point,
				schoolTrainingPoint: payload.school_training_point,
				files: payload.files || []
			}
		};

		return graphqlCmcard.mutate(queryOptions).then(response => {
			return {
				employee_point: response.data.update_employee_point
			};
		});
	},

	updateEmployeePoints(payload) {
		const queryOptions = {
			mutation: gql`mutation UpdateMultiPoints ($data: String) {
				${UPDATE_EMPLOYEE_POINTS}
			}
			`,
			variables: {
				data: payload || []
			}
		};

		return graphqlCmcard.mutate(queryOptions).then(response => {
			return {
				employee_points: response.data.update_employee_points_multi
			};
		});
	},

	updateEmployee(payload) {
		const queryOptions = {
			mutation: gql`mutation UpdateEmployee ($id: Int!, $name: String!, $properties: String) {
				update_employee(id: $id, name: $name, properties: $properties) {
					id
					name
					properties
				}
			}`,
			variables: {
				id: payload.id,
				name: payload.name,
				properties: payload.properties
			}
		};

		return graphqlCmcard.mutate(queryOptions).then(response => {
			return {
				update_employee: response.data.update_employee
			};
		});
	}
};
